import Store from "App/Store.js";

export default checkoutBasketAdditionData => Store.dispatch({type: "checkoutBasketAdditionData", checkoutBasketAdditionData});
